export const SELF_CAMPAIGN_BASE_PATH = "/self-campaign";
export const WELCOME_BACK_BASE_PATH = "/welcome-back";

type SelfCampaignStep = "create" | "design" | "activate";

const isWelcomeBackRoute = (pathname: string): boolean => {
  return (
    pathname === WELCOME_BACK_BASE_PATH ||
    pathname.startsWith(`${WELCOME_BACK_BASE_PATH}/`)
  );
};

export const resolveSelfCampaignBasePath = (pathname: string): string => {
  return isWelcomeBackRoute(pathname)
    ? WELCOME_BACK_BASE_PATH
    : SELF_CAMPAIGN_BASE_PATH;
};

export const resolveSelfCampaignStepPath = (
  pathname: string,
  step: SelfCampaignStep,
): string => {
  const basePath = resolveSelfCampaignBasePath(pathname);

  if (step === "create") {
    return basePath;
  }

  return `${basePath}/${step}`;
};
